import BodyText from 'components/Luxkit/Typography/BodyText'
import React from 'react'
import { components } from 'react-select'

type Props = React.ComponentProps<typeof components.Placeholder>

const LocationSearchFieldPlaceholder = (props: Props) => {
  const { selectProps } = props

  return (
    <components.Placeholder {...props}>
      <BodyText
        variant="large"
        colour="neutral-four"
      >
        {selectProps.placeholder}
      </BodyText>
    </components.Placeholder>
  )
}

export default LocationSearchFieldPlaceholder
